/**
 * Registro e atualização do Service Worker.
 *
 * `registerType: 'prompt'`, não `autoUpdate`: recarregar a página sozinho
 * enquanto alguém preenche uma despesa perderia o formulário. A nova versão
 * fica pronta e espera um toque.
 *
 * Este módulo não conhece React — quem chama liga o callback à interface.
 */

import { registerSW } from 'virtual:pwa-register';

import { aplicarComRedeDeSeguranca } from './atualizacao';

export interface ServiceWorkerHandle {
  /** Aplica a atualização pendente e recarrega. */
  update: () => Promise<void>;
}

export function registerServiceWorker(callbacks: {
  onUpdateAvailable: (apply: () => Promise<void>) => void;
  onOfflineReady?: () => void;
}): ServiceWorkerHandle {
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      // Versão nova achada COM o app em uso: avisa, não recarrega sozinho.
      callbacks.onUpdateAvailable(() => aplicarComRedeDeSeguranca(() => updateSW(true), () => window.location.reload()));
    },
    onOfflineReady() {
      callbacks.onOfflineReady?.();
    },
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      // Versão nova já esperando NA ABERTURA (o aparelho ficou dias com o app
      // em segundo plano): aplica agora, que ninguém está no meio de nada —
      // teste físico, 13/09: a versão nova não chegava nunca.
      if (registration.waiting) void updateSW(true);
      // E confere de novo a cada hora enquanto o app fica aberto.
      window.setInterval(() => void registration.update().catch(() => undefined), 60 * 60_000);
    },
  });

  return { update: async () => updateSW(true) };
}
